export default __webpack_public_path__ + "static/media/5.5Vid.e829e543.mp4";